'use client';

import { c as _c } from "react/compiler-runtime";
import { type FundingLimit, formatFiatUnits, fundingAllowanceUsedPercent } from '@morfi/onramp-sdk';
import { useLocale, useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedProgressCircle } from '@/components/ui/animated-progress-circle';
export function FundingAllowance(t0) {
  const $ = _c(45);
  const {
    limit,
    currency,
    decimals
  } = t0;
  const t = useTranslations("onramp");
  const locale = useLocale();
  let t1;
  if ($[0] !== t) {
    t1 = t("limit_daily");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("limit_monthly");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("limit_yearly");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      daily: t1,
      monthly: t2,
      yearly: t3
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const labels = t4;
  let t5;
  if ($[10] !== limit) {
    t5 = fundingAllowanceUsedPercent(limit);
    $[10] = limit;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const used = t5;
  const t6 = labels[limit.period];
  const t7 = `limit_${limit.period}_used`;
  let t8;
  if ($[12] !== t || $[13] !== t7) {
    t8 = t(t7);
    $[12] = t;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8 || $[16] !== used) {
    t9 = <AnimatedProgressCircle label={t8} progress={used} diameter={32} strokeWidth={3} strokeClassName="stroke-foreground-brand" trackClassName="stroke-foreground-brand" />;
    $[15] = t8;
    $[16] = used;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = labels[limit.period];
  let t11;
  if ($[18] !== t10) {
    t11 = <span className="text-foreground-secondary">{t10}</span>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== currency || $[21] !== decimals || $[22] !== limit.remainingUnits || $[23] !== locale) {
    t12 = formatFiatUnits(limit.remainingUnits, decimals, currency, locale);
    $[20] = currency;
    $[21] = decimals;
    $[22] = limit.remainingUnits;
    $[23] = locale;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12) {
    t13 = <span>{t12}</span>;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== currency || $[28] !== decimals || $[29] !== limit.limitUnits || $[30] !== locale || $[31] !== t) {
    t14 = t("allowance_total", {
      amount: formatFiatUnits(limit.limitUnits, decimals, currency, locale)
    });
    $[27] = currency;
    $[28] = decimals;
    $[29] = limit.limitUnits;
    $[30] = locale;
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t14) {
    t15 = <span className="text-foreground-secondary">{t14}</span>;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t13 || $[36] !== t15) {
    t16 = <div className="flex flex-wrap items-baseline justify-between gap-2">{t13}{t15}</div>;
    $[35] = t13;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t11 || $[39] !== t16) {
    t17 = <div className="flex min-w-0 flex-1 flex-col gap-1">{t11}{t16}</div>;
    $[38] = t11;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t17 || $[42] !== t6 || $[43] !== t9) {
    t18 = <fieldset className="flex items-center gap-3 border-t border-border-secondary pt-3 text-caption" aria-label={t6}>{t9}{t17}</fieldset>;
    $[41] = t17;
    $[42] = t6;
    $[43] = t9;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
}